import { InputType } from 'config'

export const defaultInputs = (): Record<string, InputType> => {
  return {
    reinstatementDate: {
      inputType: 'text',
      type: 'date',
      title: 'Good through Date',
      required: true,
      span: 1,
    },
    maturityDate: {
      inputType: 'text',
      type: 'date',
      title: 'Maturity Date',
      required: false,
      span: 1,
      tooltip:
        'Defaults to the maturity date on the loan. Change it to quote an extension alongside the cure: installments are counted up to it, and a maturity date on or before the Good through Date makes the whole balance due. Used for this quote only, and never saved to the loan.',
    },
    sendEmail: {
      inputType: 'select',
      title: 'Action',
      required: true,
      value: 'download',
      options: {
        download: 'Download PDF',
        email: 'Email PDF',
      },
    },
    emailTo: {
      inputType: 'text',
      title: 'Email to',
      required: false,
    },
  }
}

export const TOTAL_TITLE = 'Amount to Reinstate this Loan'
